import { RootState } from '~/store';

export const getVCardPlusReducer = (state: RootState) => state.vCardPlusReducer;
